<template>
  <div class="sidebar-notification">
    <img
      src="@/assets/chat-icons/delete.svg"
      class="delete-button"
      alt="Delete this notification"
      aria-label="Delete this notification"
      role="button"
      v-if="canClear"
      @click="deleteNotification"
    />

    <component :is="meta.sidebarNotificationComponent" :data="data" />
  </div>
</template>
<script>
// Wrapper for a sidebar notification.
import { mapGetters, mapActions } from 'vuex';
export default {
  name: 'SidebarNotification',
  props: {
    data: Object
  },
  computed: {
    ...mapGetters(['getNotificationMeta']),
    meta() {
      return this.getNotificationMeta(this.data);
    },
    canClear() {
      return this.meta.canClear
    }
  },
  methods: {
      ... mapActions([
          'handleClearOneNotification'
      ]),

      deleteNotification() {
        this.handleClearOneNotification(this.data);
      }
  }
};
</script>
<style lang="scss">
.sidebar-notification {
  position: relative;
  border-radius: 17px;
  background-color: $grey-5;
}

.delete-button {
  width: 24px;
  height: 24px;
  position: absolute;
  top: -8px;
  right: -8px;
  cursor: pointer;

  transition: transform 0.1s;

  &:hover {
      transform: scale(1.1);
  }
}
</style>
